import React, {useState,useEffect} from 'react'
import { Singleton } from '../../../js/Singleton'
import { dateReschedule, timeReschedule } from '../../../Images/Images';
import { triangle } from '../../../Images/GenericSVG';
import DateTimeSelection from './DateTimeSelection';

const language=new Singleton();

const DatePicker = ({setDateReprogram,callbackDays}) => {
    const [showCalendar,setShowCalendar]= useState(false);
    const toggleShowCalendar = () => setShowCalendar(o => !o);
    const [dateReturned, setDateReturned] = useState("");
    const [timeReturned,setTimeReturned]= useState("");

    const dateSelected=(date, time)=>{
        setDateReturned(date);
        setTimeReturned(time);
        setShowCalendar(false);
    };

    useEffect(() => {
        if(dateReturned !== "" && timeReturned !== "")
        {
            let d =dateReturned + " " + timeReturned;
            setDateReprogram(d);
        }
        
    }, [showCalendar])
    
    return (
        <div className='dpa-container'>
            <div className="containerDate" onClick={toggleShowCalendar}>
                <div className="timeReschedule dateReschedule">
                    <img className="iconDateReschedule" src={dateReschedule} alt="icon"></img>
                    <p className="textDateReschedule">{dateReturned !== "" ? dateReturned : language.getText("CallControlcallCalificationdate")}</p>
                </div>
                <div className="timeReschedule">
                    <img className="iconDateReschedule" src={timeReschedule} alt="icon"></img>
                    <p className="textDateReschedule">{timeReturned !== "" ? timeReturned : language.getText("CallControlcallCalificationhour")}</p>
                </div>
                <div className="arrowButton arrowOnly">{triangle}</div>
            </div>

            {showCalendar &&
            <div className="dpa-dateTimeContainer">
                <DateTimeSelection
                onSelectDate={(date, time) => dateSelected(date, time)}
                dataSource={callbackDays} 
                />
            </div>
            }
        </div>
    )
}

export default DatePicker


// WEBPACK FOOTER //
// ./src/components/workSpace/Others/DatePicker.jsx